import { TaskListQuery } from "@common/contracts/task.contract";
import { TaskGroupBy, TaskStatus } from "@common/types/task";
import { TaskSortValue } from "@common/types/views/tasksView";

export const NEW_TASK_PLACEHOLDER_WORKSPACE_ID = "new";

/** The tasks' order when none is picked, in List and Board. */
export const DEFAULT_TASK_SORT = TaskSortValue.CREATED_AT_DESC;

export const DEFAULT_TASK_LIST_QUERY: TaskListQuery = {
    sort: DEFAULT_TASK_SORT,
    groupBy: TaskGroupBy.STATUS,
    search: "",
    status: [TaskStatus.TODO, TaskStatus.IN_PROGRESS, TaskStatus.DONE],
};

export const ORGANIZATION_DEFAULT_TASK_STATUSES: TaskStatus[] = [
    TaskStatus.TODO,
    TaskStatus.IN_PROGRESS,
];

export const ORGANIZATION_DEFAULT_TASK_LIST_QUERY: TaskListQuery = {
    ...DEFAULT_TASK_LIST_QUERY,
    status: ORGANIZATION_DEFAULT_TASK_STATUSES,
};
